import apiKeyService from '@/shared/services/api-key.service'
import { TOAST_DISPATCHERS } from '@/shared/constants/store-constants/toast'
import {
  getQuery,
  setQuery,
  setRangeQuery,
} from '@/shared/lib/utils/queryParams'
import { checkNextPage } from '@/shared/lib/utils/pagination'
import { API_KEY_DISPATCHERS } from '@/shared/constants'

export default {
  resetStore({ commit }) {
    commit('RESET_STORE')
  },

  resetPage({ commit }) {
    commit('RESET_PAGE')
  },

  onSelectSort({ commit, dispatch }, payload) {
    commit('RESET_PAGE')
    commit('SET_SORTING', payload)

    dispatch(API_KEY_DISPATCHERS.getApiKeys, {}, { root: true })
  },

  setRange({ commit, dispatch }, payload) {
    commit('RESET_PAGE')
    commit('SET_RANGE', payload)

    setRangeQuery(['created_at_from', 'created_at_to'], payload)

    dispatch(API_KEY_DISPATCHERS.getApiKeys, {}, { root: true })
  },

  getQueryParams({ commit, dispatch }) {
    const { created_at_from, created_at_to } = getQuery()

    if (
      created_at_from &&
      created_at_to &&
      !isNaN(new Date(created_at_from).getTime()) &&
      !isNaN(new Date(created_at_to).getTime())
    ) {
      commit('SET_RANGE', [new Date(created_at_from), new Date(created_at_to)])
    }

    dispatch(API_KEY_DISPATCHERS.getApiKeys, {}, { root: true })
  },

  changePage({ commit, dispatch, state }) {
    if (checkNextPage(state.page, state.total, state.limit)) {
      commit('SET_PAGE', state.page + 1)

      dispatch(API_KEY_DISPATCHERS.getApiKeys, {}, { root: true })
    }
  },

  resetFiltersAndSorting({ commit, dispatch }) {
    commit('RESET_FILTERS_AND_SORTING')

    setQuery({})

    dispatch(API_KEY_DISPATCHERS.getApiKeys, {}, { root: true })

    commit('RESET_PAGE')
  },

  setId({ commit }, id) {
    commit('SET_ID', id)
  },

  parsePayload({ commit }, payload) {
    Object.keys(payload).forEach((key) => {
      commit('SET_FORM_DATA', { [key]: payload[key] })
    })
  },

  async createApiKey({ commit, dispatch }, payload) {
    try {
      commit('SET_ACTION_LOADING', true)

      const response = await apiKeyService.createApiKey(payload)

      dispatch('parsePayload', { ...payload, ...response })

      commit('RESET_PAGE')
      await dispatch(API_KEY_DISPATCHERS.getApiKeys, {}, { root: true })

      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })

      return { success: true }
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async updateApiKey({ commit, dispatch }, payload) {
    try {
      commit('SET_ACTION_LOADING', true)

      const response = await apiKeyService.updateApiKey(payload)

      dispatch('parsePayload', { ...payload, ...response })

      commit('RESET_PAGE')
      await dispatch(API_KEY_DISPATCHERS.getApiKeys, {}, { root: true })

      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })

      return { success: true }
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async deleteApiKey({ commit, dispatch }, key) {
    try {
      commit('SET_ACTION_LOADING', true)

      await apiKeyService.deleteApiKey(key)

      dispatch(TOAST_DISPATCHERS.setSuccessMessage, {}, { root: true })

      commit('UPDATE_ITEMS_AFTER_DELETE', key)

      return { success: true }
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
      return { success: false }
    } finally {
      commit('SET_ACTION_LOADING', false)
    }
  },

  async getApiKeys({ commit, state, dispatch }) {
    try {
      commit('SET_LOADING', true)

      const params = {
        page: state.page,
        limit: state.limit,
        ...state.sorting,
      }

      if (state.range.length) {
        params.created_at_from = state.range[0]
        params.created_at_to = state.range[1]
      }

      const response = await apiKeyService.getApiKeys(params)

      commit('SET_ITEMS', response)
    } catch (error) {
      if (!error.isHandled) {
        dispatch(TOAST_DISPATCHERS.setErrorMessage, {}, { root: true })
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },
}
